import type * as TooltipPrimitive from '@radix-ui/react-tooltip';
import React from 'react';

import { AutoneTooltip } from './Tooltip';

export const LongText = ({
  value,
  maxLength,
  className,
  tooltipSide,
}: {
  value?: string | null;
  maxLength: number;
  className?: string;
  tooltipSide?: React.ComponentPropsWithoutRef<
    typeof TooltipPrimitive.Content
  >['side'];
}) => {
  if (!value) {
    return null;
  }

  if (value.length <= maxLength) {
    return <div className={className}>{value}</div>;
  } else {
    return (
      <AutoneTooltip text={value} side={tooltipSide} asChild>
        <div className={className}>{value.slice(0, maxLength) + '...'}</div>
      </AutoneTooltip>
    );
  }
};
